import React from "react";
import { Link } from "react-router-dom";
import "../styles/TwentyTwentysixContent.css";

const reviews = [
  { quote: "The Mamahood is my go-to for anything kid or mothering-related.", author: "Sophia Amazingmama", meta: "Mom of 2" },
  { quote: "The Mamahood is so inclusive and loving which means everything.", author: "Sophia Amazingmama", meta: "Mom of 2" },
  { quote: "I just can't say enough about how much happier I am with this community.", author: "Sophia Amazingmama", meta: "Mom of 2" },
];

export default function ReviewsPage() {
  return (
    <div className="twentytwentysix-content">
      <div className="twentytwentysix-content__container">
        <p className="twentytwentysix-content__eyebrow">The Mamahood</p>
        <h1 className="twentytwentysix-content__title">What Other Mamas Are Saying</h1>
        <p className="twentytwentysix-content__copy">
          Real stories from our community. Join thousands of mamas who find support, friendship, and inspiration here.
        </p>
        <div className="twentytwentysix-content__cta-row">
          <Link to="/twentytwentysix" className="twentytwentysix-content__pill">Back to Home</Link>
        </div>

        <section className="twentytwentysix-content__section">
          <div className="twentytwentysix-content__card-grid">
            {reviews.map((r, i) => (
              <div className="twentytwentysix-content__card" key={i}>
                <h4>&quot;{r.quote}&quot;</h4>
                <p><strong>{r.author}</strong> — {r.meta}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
